module.exports = __webpack_public_path__ + "img/moon-regular.be9fb2ce.svg";